import * as React from "react";
import cx from "clsx";
import Button from "../../Button";
const Component = ({
  className: customClassName
}) => ({
  children,
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: cx("pointer-events-none", customClassName, className)
  }, children);
};
const ActiveButton = ({
  children,
  className,
  size
}) => {
  return /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    size: size,
    asComponent: Component({
      className
    })
  }, children);
};
export default ActiveButton;